import classNames from 'classnames';
import type { FunctionComponent } from 'react';
import React from 'react';
import styled from 'styled-components';

interface BodyContainerProps {
  className?: string;
  fullBodyWidth?: boolean;
  topAlign?: boolean;
  unsetMax?: boolean;
}

/**
 * Container for the page content
 */
const UnstyledBodyContainer: FunctionComponent<BodyContainerProps> = ({ className, children }) => {
  return <div className={classNames(className, 'global-body-container')}>{children}</div>;
};

export const BodyContainer = styled(UnstyledBodyContainer)`
  display: flex;
  flex-direction: column;
  justify-content: ${({ topAlign }) => (topAlign ? 'flex-start' : 'center')};

  min-height: calc(100vh - 160px);

  margin: auto;
  width: 90%;
  max-width: ${({ unsetMax }) => (unsetMax ? 'inherit' : '500px')};

  @media (max-width: 768px) {
    width: ${({ fullBodyWidth }) => (fullBodyWidth ? '100%' : '90%')};
  }
`;
